import { ApplicationController, observe, unobserve } from '@aha-app/mvc';
import type TimerWidget from '../../../../widgets/TimerWidget';

interface State {
  widget?: TimerWidget;
  active: boolean;
}

interface ControllerProps {
  widget?: TimerWidget;
}

class TimerController extends ApplicationController<State, ControllerProps> {
  widgetObserver: ReturnType<typeof observe>;

  static initialState: State = {
    active: false,
  };

  async initialize({ widget }): Promise<void> {
    this.state.widget = widget;

    this.widgetObserver = observe(() => this.setActiveFromWidget());
  }

  destroy(): void {
    unobserve(this.widgetObserver);
  }

  changeProps(newProps: ControllerProps): void {
    if (newProps.widget) {
      this.state.widget = newProps.widget;
    }
  }

  setActiveFromWidget(): void {
    const { active, widget } = this.state;

    if (active || !widget) return;

    if (widget.active() && !widget.expired()) {
      this.state.active = true;
    }
  }

  actionSetActive(active: boolean) {
    this.state.active = active;
  }
}

export default TimerController;
